import React, { useEffect, useState } from "react";

import {
  Card,
  CardBody,
  Typography,
  Dialog,
  DialogHeader,
  DialogBody,
  Button,
  CardFooter,
} from "@material-tailwind/react";

import ReportDetails from "./ReportDetails";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { updateCompanyFeesDgStatusApi } from "api/companyFees";
import { updateCompanyFeesTcpStatusApi } from "api/companyFees";

function FeesCard({ tableData, accessList, showToast, isAdmin, typeOfOp }) {
  const [openReportDetails, setOpenReportDetails] = useState(false);
  const [reportDetailsData, setReportDetailsData] = useState([]);

  useEffect(() => {
    getTableData();
  }, [tableData]);

  const getTableData = async () => {
    try {
      console.log("tableData", tableData);
      console.log("accessList", accessList);
    } catch (err) {
      console.log(err);
    }
  };

  const handleOpenReportDetails = (data) => {
    setReportDetailsData(data);
    if (accessList.Read) setOpenReportDetails(!openReportDetails);
  };

  const renderTypeLabel = (el) => {
    if (el.typeOfOp === "CV") return "Charges véhicules";
    if (el.typeOfOp === "FD") return "Frais de déplacement";
    if (el.typeOfOp === "TL") return "Frais de transport local";
    if (el.typeOfOp === "EVENEMENTS") return "Événements";
    if (el.typeOfOp === "AVOCAT") return "Avocat";
    if (el.typeOfOp === "DYNAMIC")
      return el.feesCategory?.category || "Frais dynamiques";
    return el.typeOfOp || "";
  };

  const renderDetailsLabel = (el) => {
    if (el.typeOfOp === "DYNAMIC")
      return (
        el.feesCategory?.subCategories?.find(
          (sub) => sub._id === el.feesSubCategory
        )?.name || ""
      );
    return el.details;
  };

  const renderFooterByType = (el) => {
    if (el.typeOfOp === "CV") return renderCvFooter(el);
    if (el.typeOfOp === "FD") return renderFdFooter(el);
    if (el.typeOfOp === "TL") return renderFtlFooter(el);
    if (el.typeOfOp === "EVENEMENTS") return renderEvenementsFooter(el);
    if (el.typeOfOp === "AVOCAT") return renderAvocatFooter(el);
    if (el.typeOfOp === "DYNAMIC") return renderDynamicFooter(el);
    return renderFtlFooter(el);
  };

  const handleValidateReport = (data) => {
    if (!accessList?.Validation) return;
    const validateObjectData = {
      cvValidationStaus: "N",
      fdValidationStatus: "N",
      tlValidationStatus: "N",
      evenementsValidationStatus: "N",
      avocatValidationStatus: "N",
      dynamicValidationStatus: "N",
    };

    if (data.typeOfOp === "CV") {
      validateObjectData.cvValidationStaus = "V";
    } else if (data.typeOfOp === "FD") {
      validateObjectData.fdValidationStatus = "V";
    } else if (data.typeOfOp === "TL") {
      validateObjectData.tlValidationStatus = "V";
    } else if (data.typeOfOp === "EVENEMENTS") {
      validateObjectData.evenementsValidationStatus = "V";
    } else if (data.typeOfOp === "AVOCAT") {
      validateObjectData.avocatValidationStatus = "V";
    } else if (data.typeOfOp === "DYNAMIC") {
      validateObjectData.dynamicValidationStatus = "V";
    }

    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Voulez-vous vraiment valider cette opération ?",
          confirmButtonText: "Valider",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await updateCompanyFeesTcpStatusApi(validateObjectData, data._id);
              Swal.fire("Validée", "", "success");
              showToast();
            } catch (err) {
              console.log(err);
              Swal.fire(err?.response?.data?.error, "", "error");
            } finally {
            }
          }
        });
    } catch (err) {
      console.log(err);
    }
  };
  const handleCancelReport = (data) => {
    if (!accessList?.Validation) return;
    const validateObjectData = {
      cvValidationStaus: "N",
      fdValidationStatus: "N",
      tlValidationStatus: "N",
      evenementsValidationStatus: "N",
      avocatValidationStatus: "N",
      dynamicValidationStatus: "N",
    };

    if (data.typeOfOp === "CV") {
      validateObjectData.cvValidationStaus = "A";
    } else if (data.typeOfOp === "FD") {
      validateObjectData.fdValidationStatus = "A";
    } else if (data.typeOfOp === "TL") {
      validateObjectData.tlValidationStatus = "A";
    } else if (data.typeOfOp === "EVENEMENTS") {
      validateObjectData.evenementsValidationStatus = "A";
    } else if (data.typeOfOp === "AVOCAT") {
      validateObjectData.avocatValidationStatus = "A";
    } else if (data.typeOfOp === "DYNAMIC") {
      validateObjectData.dynamicValidationStatus = "A";
    }

    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Voulez-vous vraiment annuler cette opération ?",
          confirmButtonText: "Annuler",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await updateCompanyFeesTcpStatusApi(validateObjectData, data._id);
              Swal.fire("Annulée", "", "success");
              showToast();
            } catch (err) {
              console.log(err);
              Swal.fire(err?.response?.data?.error, "", "error");
            } finally {
            }
          }
        });
    } catch (err) {
      console.log(err);
    }
  };
  const handleValidateDgReport = (status, feeId) => {
    if (!accessList?.Validation) return;
    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Voulez-vous vraiment valider cette opération ?",
          confirmButtonText: "Valider",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await updateCompanyFeesDgStatusApi(status, feeId);
              Swal.fire("Validée", "", "success");
              showToast();
            } catch (err) {
              Swal.fire(err?.response?.data?.error, "", "error");
            } finally {
            }
          }
        });
    } catch (err) {
      console.log(err);
    }
  };
  const handleCancelDgReport = (status, feeId) => {
    if (!accessList?.Validation) return;
    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Voulez-vous vraiment annuler cette opération ?",
          confirmButtonText: "Annuler",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await updateCompanyFeesDgStatusApi(status, feeId);
              Swal.fire("Annulée", "", "success");
              showToast();
            } catch (err) {
              Swal.fire(err?.response?.data?.error, "", "error");
            } finally {
            }
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  const renderCvFooter = (el) => {
    return el.cvValidationStaus === "V" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#236571" className="mr-1" disabled>
          <span>Validée</span>
        </Button>
      </CardFooter>
    ) : el.cvValidationStaus === "A" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#cf503f" className="mr-1" disabled>
          <span>Annulée</span>
        </Button>
      </CardFooter>
    ) : accessList?.Validation ? (
      <CardFooter className="flex pt-0">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleValidateReport(el)}
          className="mr-1"
        >
          <span>Valider</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelReport(el)}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
      </CardFooter>
    ) : null;
  };
  const renderFdFooter = (el) => {
    return el.fdValidationStatus === "V" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#236571" className="mr-1" disabled>
          <span>Validée</span>
        </Button>
      </CardFooter>
    ) : el.fdValidationStatus === "A" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#cf503f" className="mr-1" disabled>
          <span>Annulée</span>
        </Button>
      </CardFooter>
    ) : accessList?.Validation ? (
      <CardFooter className="flex pt-0">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleValidateReport(el)}
          className="mr-1"
        >
          <span>Valider</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelReport(el)}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
      </CardFooter>
    ) : null;
  };
  const renderFtlFooter = (el) => {
    return el.tlValidationStatus === "V" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#236571" className="mr-1" disabled>
          <span>Validée</span>
        </Button>
      </CardFooter>
    ) : el.tlValidationStatus === "A" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#cf503f" className="mr-1" disabled>
          <span>Annulée</span>
        </Button>
      </CardFooter>
    ) : accessList?.Validation ? (
      <CardFooter className="flex pt-0">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleValidateReport(el)}
          className="mr-1"
        >
          <span>Valider</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelReport(el)}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
      </CardFooter>
    ) : null;
  };

  const renderEvenementsFooter = (el) => {
    return el.evenementsValidationStatus === "V" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#236571" className="mr-1" disabled>
          <span>Validée</span>
        </Button>
      </CardFooter>
    ) : el.evenementsValidationStatus === "A" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#cf503f" className="mr-1" disabled>
          <span>Annulée</span>
        </Button>
      </CardFooter>
    ) : accessList?.Validation ? (
      <CardFooter className="flex pt-0">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleValidateReport(el)}
          className="mr-1"
        >
          <span>Valider</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelReport(el)}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
      </CardFooter>
    ) : null;
  };

  const renderAvocatFooter = (el) => {
    return el.avocatValidationStatus === "V" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#236571" className="mr-1" disabled>
          <span>Validée</span>
        </Button>
      </CardFooter>
    ) : el.avocatValidationStatus === "A" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#cf503f" className="mr-1" disabled>
          <span>Annulée</span>
        </Button>
      </CardFooter>
    ) : accessList?.Validation ? (
      <CardFooter className="flex pt-0">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleValidateReport(el)}
          className="mr-1"
        >
          <span>Valider</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelReport(el)}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
      </CardFooter>
    ) : null;
  };

  const renderDynamicFooter = (el) => {
    return el.dynamicValidationStatus === "V" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#236571" className="mr-1" disabled>
          <span>Validée</span>
        </Button>
      </CardFooter>
    ) : el.dynamicValidationStatus === "A" ? (
      <CardFooter className="flex pt-0">
        <Button variant="gradient" color="#cf503f" className="mr-1" disabled>
          <span>Annulée</span>
        </Button>
      </CardFooter>
    ) : accessList?.Validation ? (
      <CardFooter className="flex pt-0">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleValidateReport(el)}
          className="mr-1"
        >
          <span>Valider</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelReport(el)}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
      </CardFooter>
    ) : null;
  };

  return (
    <>
      <Dialog
        size="xl"
        open={openReportDetails}
        handler={handleOpenReportDetails}
      >
        <DialogHeader>
          <p className="w-full text-center"></p>
        </DialogHeader>
        <DialogBody>
          <ReportDetails
            typeOf="MOROCCO"
            reportDetailsData={reportDetailsData}
          />
        </DialogBody>
      </Dialog>

      {isAdmin
        ? tableData.map((el) => (
            <Card className="mt-6 w-full cursor-pointer dark:bg-indigo-900">
              <CardBody onClick={() => handleOpenReportDetails(el)}>
                <Typography
                  variant="h5"
                  color="blue-gray"
                  className="mb-2 dark:text-white"
                >
                  {el.responsable?.Name}
                </Typography>
                <Typography>{renderDetailsLabel(el)}</Typography>
                <Typography>{renderTypeLabel(el)}</Typography>
                <Typography>{el.montant} DH</Typography>
                <Typography>
                  {el.typeOfOp != "TL"
                    ? el?.date?.split("T")[0]
                    : el.formatedDate}
                </Typography>
                {el.typeOfOp == "TL" && (
                  <Typography>
                    {el?.fromCity?.Name || el?.startedPoint} -{" "}
                    {el?.toCity?.Name || el?.endPoint}
                  </Typography>
                )}
              </CardBody>
              {el.dgValidationStatus === "V" ? (
                <CardFooter className="flex pt-0">
                  <Button
                    variant="gradient"
                    color="#236571"
                    className="mr-1"
                    disabled
                  >
                    <span>Validée</span>
                  </Button>
                </CardFooter>
              ) : el.dgValidationStatus === "A" ? (
                <CardFooter className="flex pt-0">
                  <Button
                    variant="gradient"
                    color="#cf503f"
                    className="mr-1"
                    disabled
                  >
                    <span>Annulée</span>
                  </Button>
                </CardFooter>
              ) : el.typeOfOp === "DYNAMIC" && el.dynamicValidationStatus !== "V" ? (
                // DG validation happens after the dynamic (first-stage) validation
                <CardFooter className="flex pt-0">
                  <Typography className="text-sm italic text-gray-500">
                    attendre la premier validation
                  </Typography>
                </CardFooter>
              ) : accessList?.Validation ? (
                <CardFooter className="flex pt-0">
                  <Button
                    variant="gradient"
                    color="#236571"
                    onClick={() => handleValidateDgReport("V", el._id)}
                    className="mr-1"
                  >
                    <span>Valider</span>
                  </Button>
                  <Button
                    variant="text"
                    color="#cf503f"
                    onClick={() => handleCancelDgReport("A", el._id)}
                    className="mr-1"
                  >
                    <span>Annuler</span>
                  </Button>
                </CardFooter>
              ) : null}
            </Card>
          ))
        : tableData.map((el) => (
            <Card className="mt-6 w-full cursor-pointer dark:bg-indigo-900">
              <CardBody onClick={() => handleOpenReportDetails(el)}>
                <Typography
                  variant="h5"
                  color="blue-gray"
                  className="mb-2 dark:text-white"
                >
                  {el.responsable?.Name}
                </Typography>
                <Typography>{renderDetailsLabel(el)}</Typography>
                <Typography>{renderTypeLabel(el)}</Typography>
                <Typography>{el.montant} DH</Typography>
                <Typography>{el?.date?.split("T")[0]}</Typography>
              </CardBody>
              {renderFooterByType(el)}
            </Card>
          ))}
    </>
  );
}

export default FeesCard;
